<!-- Step 1 body — Fulfillment method (handoff §Step 1). The step header
     chrome lives in the parent's <vb-step-section>. -->

<vb-banner
    *ngIf="isPickupFlagged"
    tone="warn"
    class="dop-banner">
    <strong>Scheduling required.</strong> This order was flagged for a missed
    pickup. Please schedule a pickup or arrange shipping to continue.
</vb-banner>

<vb-banner
    *ngIf="isPayOnlyMode && hasPickupScheduled"
    tone="info"
    class="dop-banner">
    <strong>Pickup already scheduled.</strong> Payment is the only remaining
    step.
</vb-banner>

<!-- One radio group for every mode — "Pay now, pick up later" sits in the
     list alongside the fulfillment methods (in pay-only mode it arrives
     pre-selected), so the choice is always reversible by picking another
     radio. The group only disappears once a pickup is actually booked:
     nothing is left to choose, and re-confirming a method would rebook
     against the existing appointment — the banner above explains payment
     is the only remaining step. -->
<ng-container *ngIf="!(isPayOnlyMode && hasPickupScheduled)">
    <!-- FeatureFlag.PickupFulfillment: a single scheduler picker replaces
         the Pickup/Self-service pickup/Shipping radios below. -->
    <ng-container *ngIf="pickupFulfillmentEnabled; else legacyOptions">
        <div class="dop-scheduler">
            <vb-select
                label="Scheduler"
                [options]="schedulerOptions"
                [value]="isPayOnlySelected ? null : selectedSchedulerId"
                [disabled]="isPayOnlySelected"
                [placeholder]="isPayOnlySelected ? 'Not Needed' : 'Select a scheduler'"
                ariaLabel="Scheduler"
                (valueChange)="onSchedulerChange($event)">
            </vb-select>
            <p class="dop-scheduler__hint">
                {{
                    isPayOnlySelected
                        ? 'Not needed when paying only'
                        : 'Choose the appointment schedule you want to book against.'
                }}
            </p>
        </div>

        <div class="dop-payonly" *ngIf="showPayLaterOption">
            <div class="dop-payonly__text">
                <span class="dop-payonly__label">Pay only, pick up later</span>
                <span class="dop-payonly__desc">Schedule pickup later.</span>
            </div>
            <vb-toggle
                ariaLabel="Pay only, pick up later"
                [checked]="isPayOnlySelected"
                (checkedChange)="onPayOnlyToggle($event)">
            </vb-toggle>
        </div>
    </ng-container>

    <ng-template #legacyOptions>
        <div class="dop-options" role="radiogroup" aria-label="Fulfillment method">
            <vb-option-row
                *ngFor="let option of deliveryOptions"
                [label]="option.label"
                [description]="option.desc"
                [selected]="selectedDeliveryMethod === option.value"
                (clicked)="selectOption(option.value)">
            </vb-option-row>

            <vb-option-row
                *ngIf="showPayLaterOption"
                label="Pay now, pick up later"
                description="Settle the balance and schedule pickup another time."
                [selected]="isPayOnlySelected"
                (clicked)="selectOption(PAY_ONLY)">
            </vb-option-row>
        </div>
    </ng-template>

    <div class="dop-actions">
        <vb-button
            variant="primary"
            [disabled]="isConfirmDisabled"
            (clicked)="confirmSelection()">
            Confirm selection
        </vb-button>
    </div>
</ng-container>
